import React, { useEffect, useState } from "react";
import { API, getToken } from "@/api";

/**
 * Affiche une image protégée par JWT en fetchant le blob puis en créant un ObjectURL.
 * Usage : <AuthImage path="/qualiparc/interventions/xxx/photos/yyy" alt="..." />
 */
export function AuthImage({ path, alt = "", className = "", onError }) {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let objectUrl;
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${API}${path}`, {
          headers: { Authorization: `Bearer ${getToken()}` },
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const blob = await res.blob();
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      } catch (e) {
        if (!cancelled) {
          setError(true);
          onError?.(e);
        }
      }
    })();
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [path]);

  if (error) return <div className={`${className} bg-[#F1F3F5] flex items-center justify-center text-[10px] text-[#868E96]`}>Photo indisponible</div>;
  if (!url) return <div className={`${className} bg-[#F1F3F5] animate-pulse`} />;
  return <img src={url} alt={alt} className={className} />;
}
